var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle, _circle2, _circle3, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActivitySubmission = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 128,
    viewBox: "0 0 94 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49704 39.3695C9.1768 39.1429 15.3891 25.491 18.4103 18.6934L28.8899 20.676L14.445 43.618H0.566469C0.377646 43.618 0 43.4481 0 42.7683C0 41.9186 7.64734 39.6527 8.49704 39.3695Z",
    fill: "#BE7C19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4224 39.3695C81.7426 39.1429 75.5304 25.491 72.5092 18.6934L62.0295 20.676L76.4745 43.618H90.353C90.5418 43.618 90.9194 43.4481 90.9194 42.7683C90.9194 41.9186 83.2721 39.6527 82.4224 39.3695Z",
    fill: "#BE7C19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2083 23.7914C24.7552 22.6585 20.1101 20.8647 17.8442 20.1094L28.0407 23.5082L27.4742 24.3579L26.6245 24.0747L25.7748 25.4908C25.7748 25.3964 25.6615 24.9244 25.2083 23.7914Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4279 23.702C65.8811 22.5094 70.5261 20.6212 72.792 19.8262L62.5955 23.4039L63.162 24.2983L64.0117 24.0002L64.8614 25.4909C64.8614 25.3915 64.9747 24.8946 65.4279 23.702Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9954 22.0918L11.6139 33.7044M11.3307 34.2709L10.481 36.2535",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7341 82.7051L6.50679 49.1418L86.9614 49.1418L46.7341 82.7051Z",
    fill: "#DADEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7337 82.7051L86.961 116.268H6.50639L46.7337 82.7051Z",
    fill: "#DADEFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 43.4277,
    width: 93.1842,
    height: 5.42821,
    rx: 2.7141,
    fill: "#2E3CA8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.283203,
    y: 116.125,
    width: 92.901,
    height: 5.09822,
    rx: 2.54911,
    fill: "#2E3CA8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8442 20.1438C19.8269 14.007 24.9818 1.45027 29.7401 0.317331C34.4984 -0.815607 39.6533 1.35586 41.6359 2.58321C42.0136 2.86646 43.1654 3.43298 44.7515 3.43298V3.4636C46.4204 3.46327 47.6322 2.8976 48.0296 2.61472C50.1166 1.38864 55.5428 -0.780566 60.5516 0.351196C65.5603 1.48296 70.9865 14.0267 73.0735 20.157C70.0921 20.8172 63.9504 22.364 63.2348 23.2694C62.5193 24.1748 63.3342 24.2126 63.8311 24.1183L61.446 32.0406L44.7515 32.8894L44.75 32.8894V32.8893L28.8904 32.0397L26.6245 24.1091C27.0966 24.2035 27.8707 24.1658 27.191 23.2594C26.5112 22.3531 20.6766 20.8047 17.8442 20.1438Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94905 43.3343C5.66582 43.2399 4.88463 42.8463 5.09935 42.2014C5.38225 41.3516 5.85464 41.5405 6.23229 41.6349C6.48129 41.6972 6.62882 41.9181 7.08199 41.9181C7.53517 41.9181 8.02611 41.1628 8.21493 40.7852",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8654 43.6175C85.1708 43.5126 86.0131 43.0753 85.7816 42.3587C85.4766 41.4146 84.9672 41.6244 84.5601 41.7293C84.2916 41.7985 84.1326 42.044 83.644 42.044C83.1554 42.044 82.6261 41.2048 82.4225 40.7852",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3116 29.4552L12.7451 29.172M13.8781 28.6055L13.3116 28.3223",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7321 82.7025L41.9171 78.7372L40.7842 77.6043C40.973 76.9434 41.5772 75.4517 42.4836 74.7719C43.6165 73.9222 44.4662 75.9049 45.5992 75.6216C46.7321 75.3384 46.7321 70.8066 49.2812 70.8066C51.3205 70.8066 53.3409 74.5831 54.0962 76.4713L46.7321 82.7025Z",
    fill: "#909CF9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3052 33.4219L81.0046 37.1039",
    stroke: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9084 81.8539L24.3593 42.4843C24.076 38.4246 24.7558 29.9086 29.7407 28.3225C34.7442 26.7305 37.5559 28.4256 39.4962 29.5953C39.9722 29.8824 40.3959 30.1377 40.7865 30.3052C42.7667 31.1538 44.4643 31.1549 45.0329 31.1549V31.1546C45.0657 31.1546 45.1012 31.1548 45.1394 31.155C45.7792 31.1584 47.1799 31.1657 49.0975 30.3694C49.498 30.2031 49.9322 29.9494 50.4202 29.6643C52.409 28.5025 55.2912 26.8188 60.42 28.4001C65.5298 29.9755 66.2266 38.434 65.9363 42.4663L63.4431 81.8536H49.9685V43.3103L45.035 43.6168V43.6173L39.9368 43.334V81.8539H26.9084Z",
    fill: "#7B7DFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4155 35.1211V52.9649",
    stroke: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1339 43.3349C43.5629 42.8817 40.5984 37.6702 39.9375 35.1211V43.3349H50.1339Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1911 76.7585C29.6835 76.5319 34.0831 80.0629 35.9713 81.8567H21.5264C22.3761 80.2517 24.6986 76.985 27.1911 76.7585Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3951 76.2244C58.9515 75.9731 53.8719 79.8885 52.0206 81.8775L66.9487 81.8775C66.1157 80.0978 63.8387 76.4756 61.3951 76.2244Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3281 112.444L32.854 94.6M33.9869 93.467L36.2528 91.4844",
    stroke: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0905,
    cy: 86.8942,
    r: 1.35705,
    fill: "#909CF9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.8263,
    cy: 92.5582,
    r: 1.35705,
    fill: "#909CF9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.6578,
    cy: 97.6559,
    r: 1.35705,
    fill: "#909CF9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1719 110.46C24.187 110.687 18.0314 114.331 15.5767 116.125H64.293C64.3874 115.747 64.293 114.256 63.1601 111.31C61.7439 107.628 56.3624 101.68 52.6804 102.813C48.9983 103.946 46.166 112.443 41.0678 112.16C35.9696 111.877 35.4031 110.177 29.1719 110.46Z",
    fill: "#909CF9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActivitySubmission);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/activity-submission.69170a052cc4248c0a2b0b9c29012bab.svg";